import React, { useState, useEffect } from "react";
import { postReview } from "../../../../services/reviewsService";
import { getBusinessReviews } from "../../../../services/reviewsService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext";
import StarRating from "../../../../utils/StarRating";
import { getImage } from "../../../../utils/cloudinarySizing";

const BusinessReviews = ({ businessId }) => {
    const { userId } = useAuth(); // Get the logged-in user's ID
    const [reviews, setReviews] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [newReview, setNewReview] = useState({ stars: 0, text: "" });
    const navigate = useNavigate();

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const data = await getBusinessReviews(businessId);
                setReviews(data.reviews);
            } catch (err) {
                console.log(err);
            }
        };

        fetchReviews();
    }, [businessId]);

    const handleAddReview = () => {
        setShowForm((prevShowForm) => !prevShowForm);
    };

    const handleSubmitReview = async (e) => {
        e.preventDefault();
        if (newReview.stars > 0 && newReview.text.trim()) {
            const reviewData = {
                type: "business",
                id: businessId,
                rating: newReview.stars,
                comment: newReview.text,
            };

            try {
                const response = await postReview(reviewData);

                if (response.data) {
                    setReviews([response.data, ...reviews]);
                    setNewReview({ stars: 0, text: "" });
                    setShowForm(false);
                    alert("Successfully posted review");
                } else {
                    alert("Failed to post review. Please try again.");
                }
            } catch (error) {
                console.error("Error submitting review:", error);

                if (error.response?.data?.error === "You have already reviewed this profile.") {
                    alert("You already left a review for this business.");
                    setShowForm(false);
                    return;
                }

                alert("An error occurred while submitting your review.");
            }
        } else {
            alert("Please fill out all fields before submitting!");
        }
    };

    if (reviews === null) return null;

    const userAlreadyReviewed = reviews?.some(
        (review) => review.user?.id === userId
    );

    return (
        <div className="reviews-container">
            <div className="add-review-btn-wrapper">
                <div className="left-section">
                    {userId && !userAlreadyReviewed && (
                        <button
                            className="add-review-button"
                            onClick={handleAddReview}
                        >
                            <i className="fa-solid fa-plus"></i> Add Review
                        </button>
                    )}

                    {userAlreadyReviewed && (
                        <p className="already-reviewed">
                            You have reviewed this business.
                        </p>
                    )}
                </div>

                <p
                    className={`review-count ${!userId || userAlreadyReviewed ? 'align-right' : ''}`}
                >
                    {reviews.length} {reviews.length === 1 ? 'Review' : 'Reviews'}
                </p>
            </div>

            {showForm && (
                <form onSubmit={handleSubmitReview} className="add-review-form">
                    <label>
                        <StarRating
                            onRate={(rating) =>
                                setNewReview({ ...newReview, stars: rating })
                            }
                        />
                    </label>
                    <label>
                        Review:
                        <textarea
                            value={newReview.text}
                            onChange={(e) =>
                                setNewReview({ ...newReview, text: e.target.value })
                            }
                            placeholder="Write your review here..."
                        />
                    </label>
                    <button type="submit">Submit Review</button>
                </form>
            )}

            <div className="review-container">
                {reviews.map((review, index) => (
                    <div key={index} className="review-box">
                        <div className="review-content">
                            <div className="star-rating">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <i
                                        key={star}
                                        className={`fa-star ${review.rating >= star ? "fas highlighted" : "fas"}`}
                                    ></i>
                                ))}
                            </div>
                            <p className="review-text">"{review.comment}"</p>
                            <div className="review-user-info">
                                <p className="review-date">
                                    {new Date(review.created_at).toLocaleString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true
                                    })}
                                </p>

                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <img
                                        onClick={() => navigate(`/profile/${review.user.id}`)}
                                        src={getImage(review.user?.profile_image, "avatar_xsm") || '/servspace-default-40x40.png'}
                                        alt={review.user.name}
                                        className="review-user-image"
                                        onError={(e) => {
                                            e.currentTarget.onerror = null; // prevents infinite loop if fallback also fails
                                            e.currentTarget.src = '/servspace-default-40x40.png';
                                        }}
                                    />
                                    <p
                                        className="customer-name"
                                        onClick={() => navigate(`/profile/${review.user.id}`)}
                                    >
                                        {review.user.name}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BusinessReviews;